import SavingsContainer from 'containers/savings';

export default {
  exact: false,
  name: 'savings',
  protected: true,
  path: '/savings',
  component: SavingsContainer,
};
